import { render, staticRenderFns } from "./PurchasedItemPreview.vue?vue&type=template&id=c75f9648&scoped=true&lang=pug&"
import script from "./PurchasedItemPreview.vue?vue&type=script&lang=js&"
export * from "./PurchasedItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedItemPreview.vue?vue&type=style&index=0&id=c75f9648&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75f9648",
  null
  
)

/* custom blocks */
import block0 from "./PurchasedItemPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports